export default __webpack_public_path__ + "static/media/organico.5ae9b1e1.svg";